export default __webpack_public_path__ + "static/media/logo-AGIR.fc09cc5c.png";